import { render, staticRenderFns } from "./Overseas.vue?vue&type=template&id=a82f4f92&scoped=true"
import script from "./Overseas.vue?vue&type=script&lang=js"
export * from "./Overseas.vue?vue&type=script&lang=js"
import style0 from "./Overseas.vue?vue&type=style&index=0&id=a82f4f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82f4f92",
  null
  
)

export default component.exports